// core/api/usePromotionDelete.ts

import axios from "axios";
import { API_BASE_PATH } from "../../environment";
import { toast } from "react-toastify";

const PROMOTION_BASE_URL = API_BASE_PATH;

/**
 * Response format expected from DELETE /promotions/:id
 */
interface DeletePromotionResponse {
  message: string;
}

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

/**
 * Deletes a promotion record by ID
 * @param token - Authentication token
 * @param promotionId - The ID or unique identifier to delete (e.g. 'promotion240027')
 * @returns Success message or throws error
 */
export const deletePromotion = async (
  token: string | null,
  promotionId: string
): Promise<DeletePromotionResponse> => {
  if (!token) {
    const msg = "Authentication token is missing";
    toast.error(msg);
    throw new Error(msg);
  }

  try {
    const response = await axios.delete<DeletePromotionResponse>(
      `${PROMOTION_BASE_URL}/promotions/${promotionId}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Promotion deleted successfully");
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    throw new Error(msg);
  }
};
